import { styled } from 'src/components/mui';

export const ResponsiveText = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    '.header1': {
      fontSize: '40px !important',
    },
    '.header2': {
      fontSize: '35px !important',
    },
    '.header3': {
      fontSize: '30px !important',
    },
    '.header4': {
      fontSize: '25px !important',
    },
    '.header5': {
      fontSize: '20px !important',
    },
    '.header6': {
      fontSize: '15px !important',
    },
    '.header7': {
      fontSize: '15px !important',
    },
  },
  [theme.breakpoints.down('sm')]: {
    '.header1': {
      fontSize: '35px !important',
    },
    '.header2': {
      fontSize: '30px !important',
    },
    '.header3': {
      fontSize: '25px !important',
    },
    '.header4': {
      fontSize: '20px !important',
    },
    '.header5': {
      fontSize: '15px !important',
    },
    '.header6': {
      fontSize: '15px !important',
    },
    '.header7': {
      fontSize: '15px !important',
    },
  },
}));
